import { render, staticRenderFns } from "./disposalRecord.vue?vue&type=template&id=da66084a&scoped=true&"
import script from "./disposalRecord.vue?vue&type=script&lang=js&"
export * from "./disposalRecord.vue?vue&type=script&lang=js&"
import style0 from "./disposalRecord.vue?vue&type=style&index=0&id=da66084a&prod&lang=scss&"
import style1 from "./disposalRecord.vue?vue&type=style&index=1&id=da66084a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da66084a",
  null
  
)

export default component.exports